import * as React from "react";
const SvgGrid = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 16 16",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	stroke: "currentColor",
	strokeWidth: 1.5,
	d: "M5.55 0v16M11.95 0v16M16 5.55H0M16 11.95H0"
}));
export default SvgGrid;
